import 'react';
import { jsx } from '@emotion/core';

var LayoutWrapper = function LayoutWrapper(_ref) {
  var children = _ref.children;
  return jsx("div", {
    className: "h-100 d-flex flex-column pb-1"
  }, children);
};

LayoutWrapper.displayName = "LayoutWrapper";
export default LayoutWrapper;